<template>
  <b-card>
    <documento-licenca-list
      id="documentoLicencaList"
      ref="documentoLicencaList"
      :carregar="carregar"
      :novo="novo"
      :editar="editar"
      :remover="remover"
      :colunas="colunasListagem"
      :filtros="filtrosPrincipais"
      :info="info"
      :mostrar-remover-lote="false"
    >
      <template slot="botoes-adicionais">
        <b-button
          variant="success btn-sm"
          style="margin-right: 5px;"
          @click="exportarRelatorio"
        >
          Exportar
        </b-button>

        <filtro-adicional-base
          :target="'filtroAdicionalBase'"
          @limpar="LimpaFiltros"
          @aplicar-busca="pesquisarFiltroDocumentoLicenca"
        >
          <template #conteudo-filtro-adicional>
            <b-row class="search-group mb-1">
              <b-col cols="12">
                <b-form-group
                  label="Data de Emissão"
                >
                  <de-para
                    ref="dataEmissao"
                    v-model="dataEmissao"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="Data de Vencimento"
                >
                  <de-para
                    ref="dataVencimento"
                    v-model="dataVencimento"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="search-group mb-1">
              <b-col cols="12">
                <b-form-group
                  label="Tipo de Documento/Licença"
                >
                  <b-select
                    v-model="filtros.tipoDocumentoLicenca"
                    class="search-items"
                    :placeholder="'Tipo de Documento/Licença'"
                  >
                    <option
                      v-for="(documentoLicenca, index) in tipoDocumentoLicenca"
                      :key="index"
                      :value="documentoLicenca.value"
                    >{{ documentoLicenca.text }}</option>
                  </b-select>
                </b-form-group>
              </b-col>
            </b-row>
          </template>
        </filtro-adicional-base>
      </template>
      <template
        slot="botao-adicional"
        slot-scope="{props}"
      >
        <b-btn
          v-if="userData != null && userData.observacaoDocumentoLicenca && !permissaoUpdate "
          v-b-tooltip.hover
          title="Editar observação do documento"
          variant="none"
          class=" btn-none rounded-pill icone-acao btn-acoes-historico"
          style="margin-right:0.3rem"
          @click="editarObservacao(props.row)"
        >
          <feather-icon icon="Edit2Icon" />
        </b-btn>
        <b-btn
          v-b-tooltip.hover
          title="Histórico de ações"
          variant="none"
          class=" btn-none rounded-pill icone-acao"
          :class="props.row.tipo == 'A3' ? 'btn-acoes-download-disabled' : 'btn-acoes-historico'"
          style="margin-right:0.3rem"
          :disabled="props.row.tipo == 'A3'"
          @click="showHistoricos(props.row.id)"
        >
          <font-awesome-icon :icon="faHistory" />
        </b-btn>
      </template>
      <template slot="botao-filtro-documento-licenca">
        <div class="col-6 search-group">
          <label
            name="filtroLabelDocumentoLicenca"
            for="filterDocumentoLicenca"
            style="left: 1.5rem !important;top: calc( 50% - 0.8rem ) !important;"
            class="fas fa-filter icon"
          />
          <a
            id="downloadRelatorio"
            download
            href=""
          />
          <b-select
            v-model="filtros.tipoFiltroDocumentoLicenca"
            name="filterDocumentoLicenca"
            class="search-items"
            :placeholder="'Filtro por documento/licença'"
            @change="pesquisarFiltroDocumentoLicenca"
          >
            <option
              v-for="(DocumentoLicenca, index) in filtroDocumentoLicenca"
              :key="index"
              :value="DocumentoLicenca.value"
            >{{ DocumentoLicenca.text }}</option>
          </b-select>
        </div>
      </template>
      <template
        slot="celula-personalizada"
        slot-scope="{props}"
      >
        <span v-if="props.column.field === 'dataEmissao'">
          {{ props.row.dataEmissao ? formatDate(props.row.dataEmissao) : '-' }}
        </span>
        <span v-if="props.column.field === 'dataVencimento' && validaVencido(props.row.dataVencimento)">
          <span style="color: #ea5455;">{{ props.row.dataVencimento ? formatDate(props.row.dataVencimento) : '-' }}</span>
        </span>
        <span v-else-if="props.column.field === 'dataVencimento'">
          {{ props.row.dataVencimento ? formatDate(props.row.dataVencimento) : '-' }}
        </span>
        <span
          v-else-if="props.column.field === 'empresaRazaoSocial'"
          :class=" permissaoUpdate && props.column.editable ? 'editable-column' : ''"
          @click="editar(props.row)"
        >
          {{ props.row.empresaRazaoSocial }}
          <span
            v-b-tooltip.hover
            :title="props.row.statusCertificado ? 'Solicitação registrada e está em fase de emissão':''"
            :class="['ativo-badge', {'badge badge-success':props.row.status === 'Ativo',
                                     'badge badge-danger': props.row.status === 'Inativo',
                                     'badge badge-vencido': props.row.status === 'Vencido',
                                     'badge badge-em-processo': props.row.status === 'Em Processo' }]"
          >
            {{ props.row.status === 'Ativo' ? 'Ativo' : props.row.status === 'Inativo' ? 'Inativo' : props.row.status === 'Em Processo' ? 'Em Processo' : 'Vencido' }}
          </span>
        </span>
        <span
          v-else-if="props.column.field === 'observacoes'"
          v-b-tooltip.hover
          :title="props.row.observacoes || ''"
        >
          <p
            style="overflow: hidden; width:25ch; text-overflow: ellipsis; white-space:nowrap;"
          >
            {{ props.row.observacoes || '-' }}
          </p>
        </span>
      </template>
    </documento-licenca-list>
    <historico-documento-licenca
      ref="historicoDocumentoLicenca"
      :documento-licenca-id="1"
    />
  </b-card>
</template>

<style lang="scss">
#documentoLicencaList .editable-column {
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
}

.linha-vertical {
  height: 30px;/*Altura da linha*/
  border-right: 1px solid rgb(163 164 166 / 88%);/* Adiciona borda direita na div como ser fosse uma linha.*/
}

.badge-dados-empresa {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}

.badge-dados-controle {
  height: 1.3rem;
  font-size: 10px;
  font-weight: 750;
  border-radius: 2px;
  margin-left: 0.5rem;
  padding: 4px;
}

.badge-parcial {
  background-color: #ff8d00;
}

.badge-controle {
  border-width: 1px;
  border-style: solid;
}

.badge-vencido {
  color: #ea5455;
  border: 1px solid #ea5455;
  background-color: transparent;
}

.badge-em-processo {
  color: #fff;
  border: 1px solid #c1af1d;
  background-color: #c1af1d;
}

.btn-acoes-download {
  border: 1px solid #1d9553 !important;
  background-color: transparent;
  color: #1d9553 !important;

  :hover {
    color: #1d9553 !important;
  }
}

.btn-acoes-historico {
  border: 1px solid #c1af1d !important;
  background-color: transparent;
  color: #c1af1d !important;

  :hover {
    color: #c1af1d !important;
  }
}

.btn-acoes-download-disabled {
  border: 1px solid #82868b !important;
  background-color: transparent;
  color: #82868b !important;

  :hover {
    color: #82868b !important;
  }
}

</style>

<script>
import moment from 'moment'
import { formatDate } from '@core/utils/utils'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faDownload, faHistory } from '@fortawesome/free-solid-svg-icons'
import { can } from '@core/libs/acl/utils'
import api from '@/app-modulo/comuns/documentos-e-licencas/shared/services/api'
import { getUserData } from '@/auth/utils'
import HistoricoDocumentoLicenca from '@/app-modulo/comuns/documentos-e-licencas/shared/components/historico-documento-licenca/HistoricoDocumentoLicenca.vue'

export default {
  name: 'EmpresaVisualizacao',
  components: {
    FontAwesomeIcon,
    DocumentoLicencaList: () => import('@/shared/components/visualizacao-base/VisualizacaoBase.vue'),
    FiltroAdicionalBase: () => import('@/shared/components/filtro-adicional-base/FiltroAdicionalBase.vue'),
    HistoricoDocumentoLicenca,
    DePara: () => import('@/shared/components/de-para/DePara.vue'),
  },
  data() {
    return {
      faDownload,
      faHistory,
      colunasListagem: [
        {
          label: 'Documento/Licença', field: 'empresaRazaoSocial', showActive: true, type: 'personalizada',
        },
        { label: 'Tipo', field: 'tipo' },
        { label: 'Emissão', field: 'dataEmissao', type: 'personalizada' },
        { label: 'Vencimento', field: 'dataVencimento', type: 'personalizada' },
        { label: 'Observação', field: 'observacoes', type: 'personalizada' },
      ],
      filtrosPrincipais: [
        { colunas: ['Tipo', 'Modelo', 'empresaRazaoSocial', 'dataVencimento', 'porProcuracao'], valor: null },
      ],
      dataVencimento: {
        dataInicio: null,
        dataFim: null,
      },
      dataEmissao: {
        dataInicio: null,
        dataFim: null,
      },
      filtros: {
        tipoFiltroDocumentoLicenca: 1,
        tipoDocumentoLicenca: null,
      },
      disabledDates: {},
      filtroDocumentoLicenca: [
        { text: '', value: 0 },
        { text: 'Documentos ativos', value: 1 },
        { text: 'Documentos inativos', value: 2 },
        { text: 'Documentos vencidos', value: 3 },
        { text: 'Documentos à vencer nos próximos 30 dias', value: 4 },
        { text: 'Documentos com dispensa de alerta', value: 5 },
        { text: 'Documentos em processo', value: 6 },
      ],
      tipoDocumentoLicenca: [
        { value: '1', text: 'Funcionamento' },
        { value: '2', text: 'Sanitário' },
        { value: '3', text: 'Corpo de Bombeiros' },
        { value: '4', text: 'Ambiental' },
        { value: '5', text: 'Outros' },
      ],
      info: [
        { label: 'Data de cadastro: ', campo: 'dataCadastro', format: 'date' },
        { label: 'Cadastrado por: ', campo: 'usuCadastro' },
        { label: 'Data de alteração: ', campo: 'dataAlteracao' },
        { label: 'Alterado por: ', campo: 'usuAlteracao' },
      ],
      carregado: false,
      userData: null,
    }
  },
  computed: {
    permissaoCreate: {
      get() {
        return can('create', this.$route.meta.resource)
      },
    },
    permissaoUpdate: {
      get() {
        return can('update', this.$route.meta.resource)
      },
    },
  },
  created() {
    this.userData = getUserData()
  },
  methods: {
    pesquisarFiltroDocumentoLicenca() {
      this.$refs.documentoLicencaList.montarGrid()
    },
    carregar(page, pageSize, filtro) {
      this.carregado = true
      const filtros = {
        filtroPricipal: filtro,
        filtrosAdicionais: this.filtros,
        dataVencimento: this.dataVencimento,
        dataEmissao: this.dataEmissao,
      }

      return api.getDocumentoLicencas(page, pageSize, filtros)
    },
    novo() {
      this.$router.push({ name: 'novo-documento-licenca' })
    },
    exportarRelatorio() {
      const filtros = {
        filtroPricipal: {
          filtroBy: [
            { colunas: ['Tipo', 'Modelo', 'empresaRazaoSocial', 'dataVencimento', 'porProcuracao'], valor: null },
          ],
          ordemBy: [
            {
              coluna: '',
              tipo: '',
            },
          ],
        },
        filtrosAdicionais: this.filtros,
        dataVencimento: this.dataVencimento,
        dataEmissao: this.dataEmissao,
      }
      api.exportarRelatorio(filtros)
        .then(response => {
          if (response.data.url !== '') {
            document.getElementById('downloadRelatorio').href = response.data.url
            document.getElementById('downloadRelatorio').click()
          }
          this.deletarUpload(response.data.fileName)
        }).catch(err => {
          this.$erroResponse(err)
          throw err
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
          .then(resolve => {
            this.$isLoading(false)
            this.$sucesso('Planilha gerada com sucesso')
            resolve()
          })
      }, 3000)
    },
    editar(value) {
      this.$router.push({ name: 'ver-documento-licenca', params: { id: value.id } })
    },
    editarObservacao(value) {
      if (!this.permissaoUpdate) {
        this.$router.push({ name: 'editar-observacao', params: { id: value.id } })
      }
    },
    remover(values) {
      if (values && values.length === 1) {
        return new Promise((resolve, reject) => {
          api.delete(values[0].id)
            .then(() => {
              resolve(false)
            })
            .catch(err => {
              reject(err)
            })
        })
      }

      const idList = values.map(map => map.id)
      return new Promise((resolve, reject) => {
        api.deleteAll({ identificadores: idList })
          .then(() => {
            resolve(false)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    validaVencido(dataDeVencimento) {
      const nowString = moment().format('DD/MM/YYYY')
      const now = moment(nowString, 'DD/MM/YYYY').toDate()
      const data = moment(dataDeVencimento, 'DD/MM/YYYY').toDate()
      return data < now
    },
    showHistoricos(id) {
      this.$refs.historicoDocumentoLicenca.show(id)
    },
    LimpaFiltros() {
      this.dataVencimento = {
        dataInicio: null,
        dataFim: null,
      }
      this.dataEmissao = {
        dataInicio: null,
        dataFim: null,
      }
      this.filtros.tipoDocumentoLicenca = null
      this.filtros.tipoFiltroDocumentoLicenca = 1
      this.$refs.documentoLicencaList.montarGrid()
    },
    formatDate(data) {
      return formatDate(data)
    },
  },
}
</script>
